import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, EventEmitter, computed, input } from "@angular/core";

import { EnabledPipe } from "../../../helpers/enabledpipe/enabledpipe";
import { SelfServiceCommandKeys } from "../../../helpers/enums/selfServiceCommands";
import { StartLoadMessage } from "../../../helpers/self-service/models/types";
import { ModifyLightPath, ModifyRedundantLightPath } from "../../../helpers/self-service/modify_lightpath";
import { SelfServiceCommand } from "../../../helpers/self-service/self-service-command";
import { LightPathBothSubscriptionDetails } from "../../../pages/subscription-detail/types";
import { SelfserviceWizard } from "../selfservice-wizard/selfservice-wizard";

@Component({
  selector: "selfservice-rps",
  templateUrl: "selfservice-rps.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [EnabledPipe, SelfserviceWizard, TranslatePipe],
})
export class SelfserviceRps {
  protected subscription = input.required<LightPathBothSubscriptionDetails>();
  protected bus = input.required<EventEmitter<StartLoadMessage>>();

  protected remotePortShutdown = computed(() => this.subscription().circuits[0].remotePortShutdown);
  private isRedundant = computed(() => this.subscription().product.tag === "LR");

  protected readonly buildCommand = () => {
    const action =
      this.isRedundant() ? SelfServiceCommandKeys.ModifyRedundantLightpath : SelfServiceCommandKeys.ModifyLightpath;
    const modify = this.isRedundant() ? new ModifyRedundantLightPath() : new ModifyLightPath();
    modify.subscription = this.subscription();
    modify.remotePortShutdown = !this.remotePortShutdown();
    const command = new SelfServiceCommand(this.subscription().subscriptionId, action);
    command.payload = modify;
    return { command, action };
  };
}
